module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/jan-wagner-cf0cf37a3c510b4da7b796afa9bdd933.png";